import { render, staticRenderFns } from "./EchartsCustomSetting.vue?vue&type=template&id=e060854c&scoped=true"
import script from "./EchartsCustomSetting.vue?vue&type=script&lang=js"
export * from "./EchartsCustomSetting.vue?vue&type=script&lang=js"
import style0 from "./EchartsCustomSetting.vue?vue&type=style&index=0&id=e060854c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060854c",
  null
  
)

export default component.exports